import { Button } from '@mui/material'
import { FlexBoxColumn } from 'components/atoms'
import { BetKeyboard, BetValidator } from 'components/molecules'
import { useBetContext } from 'contexts/BetContext'

export const BetKeyboardModal = () => {
    const { focusedInputId, setFocusedInputId, selectedBets, mainColor } =
        useBetContext()
    const currentBetAmount = selectedBets.get(focusedInputId!)?.stake || 0

    return (
        <FlexBoxColumn>
            <BetValidator
                hideActions
                betAmount={currentBetAmount}
                sx={{ backgroundColor: 'white', width: '100%' }}
            />
            <BetKeyboard />
            <Button
                variant="contained"
                sx={{
                    width: '80%',
                    mt: 1,
                    mb: 2,
                    fontWeight: 'bold',
                    textTransform: 'uppercase',
                    backgroundColor: mainColor
                }}
                disabled={focusedInputId === null}
                onClick={() => setFocusedInputId(null)}
            >
                Valider ma mise
            </Button>
        </FlexBoxColumn>
    )
}
